import { useState } from "react";
import Wrapper from "../../../components/UI/Wrapper";
import SearchIcon from "@mui/icons-material/Search";
import Bills from '../../../Icons/Bills.png'
import filterIcon from "../../../Icons/filterIcon.png";

const ProfitAndLoss = () => {

    const[expenseDetailResponse,setExpenseDetailResponse]=useState([''])

return (
    <div>
    <div
      style={{ overflowX: "hidden" }}
      className="container-fluid container-viewLeadDetails py-0 px-1"
    >
      <Wrapper className="LeadDetails">
      <div style={{ display: "flex", justifyContent: "space-between",marginBottom:"20px" }}>
                  <button className="filterButton">
                    <img src={filterIcon} />
                    {" "}FILTER
                  </button>
                  
                  
                  <div style={{ display: "flex",justifyContent:'space-between' }}
                  
                  >
                    <div style={{border:'2px solid #C0C6CC',display:'flex',justifyContent:'center',alignItems:'center',borderRadius:'8px',marginLeft:'10px'}}> 
                     <h4 className="px-2" style={{color:'#6A6A6A',fontSize:'14px',fontWeight:'600',margin:'0px'}}>Sales :
                        <span style={{color:'#5B489D',fontSize:'14px'}}> ₹ 10,00,00,000</span>
                     </h4>
                    </div>
                    <div style={{border:'2px solid #C0C6CC',display:'flex',justifyContent:'center',alignItems:'center',borderRadius:'8px',marginLeft:'10px'}}> 
                     <h4 className="px-2" style={{color:'#6A6A6A',fontSize:'14px',fontWeight:'600',margin:'0px'}}>C.O.G.S :
                        <span style={{color:'#5B489D',fontSize:'14px'}}> ₹ 10,00,00,000</span>
                     </h4>
                    </div>
                    <div style={{border:'2px solid #C0C6CC',display:'flex',justifyContent:'center',alignItems:'center',borderRadius:'8px',marginLeft:'10px'}}> 
                     <h4 className="px-2" style={{color:'#6A6A6A',fontSize:'14px',fontWeight:'600',margin:'0px'}}>G. P. :
                        <span style={{color:'#5B489D',fontSize:'14px'}}> ₹ 10,00,00,000</span>
                     </h4>
                    </div>
                  </div>
                  
                </div>
          <>
          <hr/>
         
            <div  className="container-fluid px-0">
      <div className="expenseList">
      <h2
                  className="Venderheading"
                  style={{
                    fontSize: "22px",
                    paddingLeft: "16px",
                    paddingTop: "7px",
                  }}
                >
                Profit & Loss
                </h2>
                <table style={{width:"100%"}}  className="table_expense">
  <thead>
    <tr className="expenseListHeading">
      <th>S.No.</th>
      <th>Job Type or SOW</th>
      <th>Qty.</th>
      <th colSpan="2">Sale</th> 
      <th colSpan="2">Purchase</th> 
      <th>Gross Profit</th>
      <th>Operating Expense</th>
      <th>Income Tax</th>
      <th>Net Profit</th>
      <th className="text-center">%</th>
    </tr>
    <tr className="expenseListHeading">
      <th colSpan=""></th> 
      <th colSpan=""></th> 
      <th colSpan=""></th> 
      <th>Unit Price</th> 
      <th>Amount</th>
      <th>Unit Price</th> 
      <th>Amount</th>
      <th></th>
      <th></th>
      <th></th>
      <th></th>
      <th></th>
    </tr>
  </thead>
  <tbody>
    {expenseDetailResponse !== null ? (
      expenseDetailResponse.map((expense, index) => (
        <>
        <tr key={index+1}>
          <td>12 Dec 2024</td>
          <td>Air Freight</td>
          <td>01</td>
          <td>₹ 59,999</td> 
          <td>₹ 59,999</td> 
          <td>₹ 29,999</td> 
          <td>₹ 29,999</td> 
          <td>₹ 30,000</td> 
          <td>₹ 2,000</td> 
          <td>₹ 1,500</td>
          <td>₹ 1,500</td>
         <td>87%</td>
        </tr>
        <tr key={index+1}>
          <td>12 Dec 2024</td>
          <td>Air Freight</td>
          <td>01</td>
          <td>₹ 59,999</td> 
          <td>₹ 59,999</td> 
          <td>₹ 29,999</td> 
          <td>₹ 29,999</td> 
          <td>₹ 30,000</td> 
          <td>₹ 2,000</td> 
          <td>₹ 1,500</td>
          <td>₹ 1,500</td>
         <td>87%</td>
        </tr>
        <tr key={index+1}>
          <td>12 Dec 2024</td>
          <td>Air Freight</td>
          <td>01</td>
          <td>₹ 59,999</td> 
          <td>₹ 59,999</td> 
          <td>₹ 29,999</td> 
          <td>₹ 29,999</td> 
          <td>₹ 30,000</td> 
          <td>₹ 2,000</td> 
          <td>₹ 1,500</td>
          <td>₹ 1,500</td>
         <td>87%</td>
        </tr>
        <tr key={index+1}>
          <td>12 Dec 2024</td>
          <td>Air Freight</td>
          <td>01</td>
          <td>₹ 59,999</td> 
          <td>₹ 59,999</td> 
          <td>₹ 29,999</td> 
          <td>₹ 29,999</td> 
          <td>₹ 30,000</td> 
          <td>₹ 2,000</td> 
          <td>₹ 1,500</td>
          <td>₹ 1,500</td>
         <td>87%</td>
        </tr>
        </>
        
      ))
    ) : (
      <tr>
        <td colSpan="15">No expenses available</td>
      </tr>
    )}
  </tbody>
</table>

      </div>
    </div>
    
          </>
      </Wrapper>
    
    </div>
   
</div>
)
}

export default ProfitAndLoss;

